<script lang="ts">
  import type { HTMLAttributes } from 'vue'
  import type { ButtonProps } from '../../ui/button'
  import type { IconComponent } from '@gat-ship/icons'
  export interface DataListItemActionProps {
    class?: HTMLAttributes['class']
    variant?: ButtonProps['variant']
    size?: ButtonProps['size']
    disabled?: boolean
    icon?: IconComponent | false
    dataTestid?: string
    testId?: string
  }
</script>

<script setup lang="ts">
  import { Button } from '../../ui/button'
  import { cn } from '../../../lib/utils'
  import { IconDotsVertical } from '@gat-ship/icons'

  const props = withDefaults(defineProps<DataListItemActionProps>(), {
    icon: () => IconDotsVertical
  })
</script>

<template>
  <Button
    :variant="props.variant ?? 'ghost'"
    :size="props.size ?? 'icon'"
    :disabled="props.disabled"
    :class="cn('group-hover:bg-background hover:bg-neutral-300', props.class)"
    :data-testid="props.testId ?? props.dataTestid"
  >
    <component :is="props.icon" v-if="props.icon" class="size-4" />
    <slot />
  </Button>
</template>
